const CATEGORIA = {
  INFORMATIVA: 'Informativa',
  ALERTA: 'Alerta',
  RECORDATORIO: 'Recordatorio',
}

export default CATEGORIA
